import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

import { useIsMobile } from '@/hooks';

import { useChangeLocationMutation } from '@/mutations';

import { SidebarMenuProps } from '@/types';

export const LocationSwitcher = (props: SidebarMenuProps['location_props']) => {
  const { current_location_id, locations, url } = props;
  const isMobile = useIsMobile();

  const currentLocation = (locations || []).find(
    (location) => location.id === current_location_id,
  );

  const { mutate: changeLocation, isPending: isChangeLocationPending } =
    useChangeLocationMutation();

  const onLocationChange = (locationId: number) => {
    if (!url || locationId === current_location_id) {
      return;
    }

    changeLocation(
      {
        locationId,
        url,
      },
      {
        onSuccess: (res) => {
          if (res?.status === 'ok') {
            window.location.reload();
          }
        },
      },
    );
  };

  if (!locations || locations.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        asChild
        className="focus-visible:outline-none"
      >
        <Button
          variant="outline"
          size="sm"
          disabled={isChangeLocationPending}
          className="bg-main-menu-background hover:bg-main-menu-background/80 text-main-menu-foreground border-border border text-sm sm:text-base"
        >
          {currentLocation?.name || ''}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align={isMobile ? 'center' : 'start'}
        collisionPadding={8}
        className="dark bg-main-menu-background text-main-menu-foreground"
      >
        {locations.map((location) => (
          <DropdownMenuCheckboxItem
            key={location.id}
            className="cursor-pointer"
            checked={location.id === current_location_id}
            onCheckedChange={() => {
              onLocationChange(location.id);
            }}
            disabled={isChangeLocationPending}
          >
            {location.name}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
